import React, { useContext, useState, useRef, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import { useApiContext } from "../context/ApiContext.jsx";
import { AuthContext } from "../context/AuthContext.jsx";
import UserItem from './UserItem.jsx';
import { arraysEqual } from '../helpers/objectDiff.js';


const Tournament = ({ activeTab }) => {
	const { api } = useApiContext();
	const { sessionInfo, setSessionInfo } = useContext(AuthContext);
	//const [tournamentResults, setTournamentResults] = useState(null);
	const prevItemsRef = useRef([]);
	const usersRef = useRef([]);

	const { data: tournament = { items: [] } } = useQuery({
		queryKey: ['tournament-status'],
		queryFn: async () => {
			const { data } = await api.get(`/api/trivia/tournament-results`);
			//const { data } = await api.get(`/react-app/json/tournament-results.json`);
			return data; // <= puro
		},
		// Trasforma il dato: tieni solo gli utenti "attivi"
		//select: (data) => {
		//	const items = (data?.items ?? []).filter(el => el.type === 1);
		//	return { ...data, items };
		//},
		keepPreviousData: true,
		// Usa il dato della query per decidere quando stoppare il polling
		refetchInterval: (query) => {
			const d = query.state.data;
			if (!d?.items?.length) return 15000;
			const allDone = d.items.every(r => r.completed);
			return allDone ? false : 15000;
		},
		placeholderData: (prev) => prev ?? { items: [] },
	});

	useEffect(() => {
		const items = tournament?.items ?? [];
		if (!items.length) return;

		// Se la lista è cambiata, gestisci animazioni out->in
		const changed = !arraysEqual(prevItemsRef.current, items);
		if (changed) {
			// anima out i precedenti
			usersRef.current.forEach((item) => {
				if (!item) return;
				item.classList.remove('animate__fadeInLeft');
				item.classList.add('animate__fadeOutLeft');
			});

			// poi anima in i nuovi
			setTimeout(() => {
				usersRef.current.forEach((item) => {
					if (!item) return;
					if (item.classList.contains('animate__fadeOutLeft')) {
						item.classList.remove('animate__fadeOutLeft');
						item.classList.add('animate__fadeInLeft');
					}
				});
			}, 1200);

			prevItemsRef.current = items;
		}
	}, [tournament.items])

	const advancementRate = Number(tournament?.advancementRate ?? 0);
	const isSingular = advancementRate <= 1;

	return (
		<>
			<div className={`animate__animated animate__fadeIn px-2 px-sm-3 px-lg-5 w-100 mt-5 mt-sm-7 ${activeTab != 2 ? "d-none" : ""}`} style={{ animationdDuration: "0.3s" }}>
				<h2 className="fw-bold d-flex flex-column align-items-center mb-4">
					<i className="bi bi-trophy me-3" style={{ fontSize: "4rem" }}></i>
					{tournament.name}
					<div className="fw-normal d-flex align-items-center fs-5 mt-4" role="alert">
						<i className="bi bi-info-circle me-2"></i>
						{isSingular ? "Il migliore" : `I migliori ${advancementRate}`} &nbsp;di ogni gara {isSingular ? "accede" : "accedono"} alla finale
					</div>
				</h2>

				<div className="tournament-grid room-status">
					{tournament.items.map((el, index) => {
						return <div key={index} className="room-container">
							<h3>{el.roomName} <small className="fs-7 text-warning ms-2">{el.completed ? "" : "in corso"}</small></h3>
							<div>
								<div className="user-items-list">
									{el.items.map((user, uIndex) => {
										return <UserItem
											className={`${el.completed ? "" : "shimmer"}`}
											key={user.id ?? uIndex}
											user={{ ...user, isCompleted: true, totalScore: (user.totalScore ? user.totalScore : "0") }}
											index={uIndex}
											isFinalStep={true}
											usersRef={usersRef}
										>
											<div className="user-item-ranking">{uIndex + 1}</div>
										</UserItem>
									})}
								</div>
							</div>
						</div>
					})}
				</div>
			</div>
		</>
	);
};

export default Tournament;
